import Axios from "@/plugins/Axios";

export class PlanosAnuaisService {
  async planoAnual(gestaoDeAulaId) {
    const response = await Axios().get(`planos-anuais/plano-anual/${gestaoDeAulaId}`);
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-anuais/criar-plano-anual`, {
      plano,
    });
    return response.data;
  }

  async disciplinas() {
    const response = await Axios().get(`planos-anuais/disciplinas`);
    return response;
  }

  async turmas() {
    const response = await Axios().get(`planos-anuais/turmas`);
    return response;
  }

  async bimestres() {
    const response = await Axios().get(`planos-anuais/listarBimestres`);
    return response;
  }

  async index(pageNumber, query, turma, disciplina) {
    const planos = await Axios().get(
      `planos-anuais/planos-anuais?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}`
    );
    return planos.data;
  }

  async pdf(planoId) {
    const base64 = await Axios()
      .get(`planos-anuais/${planoId}/relatorio`, { responseType: "arraybuffer" })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));
    return `data:application/pdf;base64, ${base64}`;
  }

  async show(planoId) {
    const response = await Axios().get(`planos-anuais/${planoId}/visualizar`);
    return response;
  }

  async update(planoId, statusId) {
    const response = await Axios().put(`planos-anuais/${planoId}/${statusId}/atualizarSituacao`);
    return response.data;
  }
}
export default new PlanosAnuaisService();
